import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import DropDown from "../../Common/Forms/DropDown";
import FromToDateTimePickerNative from "../../Common/Forms/FromToDateTimePickerNative";
import TextInput from "../../Common/Forms/TextInput";
import LoadButton from "../../Common/LoadButton";

import { getAktorer } from "../../../actions/aktorerActions";
import { getElsparksykkelGebyr } from "../../../actions/elsparksykkelGebyrActions";
import {
  handleChange as handleChangeAction,
  handleChangeToInitState as handleChangeToInitStateAction,
} from "../../../actions/handleChangeAction";

import { visAlleJaNei } from "../../../constants/globals";
import * as inputValidation from "../../../utils/inputValidationUtils";
import { IsValidated } from "../../../utils/validationUtils";

const rules = {
  ileggelsesnummer: "isPositiveInteger",
  tjenestenummer: "isPositiveInteger",
};

const FilterForm = () => {
  const [touched, setIsTouched] = useState(false);
  const [showSokSpinner, setShowSokSpinner] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAktorer());
  }, [dispatch]);

  const elsparksykkelGebyrFilterForm = useSelector(
    (store) => store.forms.elsparksykkelGebyrFilterForm,
  );

  const elsparksykkelGebyr = useSelector((store) => store.elsparksykkelGebyr);

  const aktorer = useSelector((store) => store.aktorer);

  const getPropsAsFakeState = () => {
    return {
      ileggelsesnummer: elsparksykkelGebyrFilterForm.ileggelsesnummer,
      tjenestenummer: elsparksykkelGebyrFilterForm.tjenestenummer,
      validationError: {
        ileggelsesnummer: elsparksykkelGebyrFilterForm.ileggelsesnummer,
        tjenestenummer: elsparksykkelGebyrFilterForm.tjenestenummer,
      },
    };
  };

  const isValid = (eventName = undefined, eventValue = undefined) => {
    let propsAsFakeState =
      eventName && eventValue
        ? { ...getPropsAsFakeState(), [eventName]: eventValue }
        : getPropsAsFakeState();
    const { isValid, validationError } = IsValidated(propsAsFakeState, rules);
    dispatch(
      handleChangeAction(
        "ELSPARKSYKKEL_GEBYR_FILTER_FORM",
        "validationError.ileggelsesnummer",
        validationError.ileggelsesnummer,
      ),
    );
    dispatch(
      handleChangeAction(
        "ELSPARKSYKKEL_GEBYR_FILTER_FORM",
        "validationError.tjenestenummer",
        validationError.tjenestenummer,
      ),
    );

    const fraDateTimeTilDateTimeValid =
      inputValidation.fraDateTimeTilDateTimeValidation(
        elsparksykkelGebyrFilterForm,
        (name, value) =>
          dispatch(
            handleChangeAction(
              "ELSPARKSYKKEL_GEBYR_FILTER_FORM",
              `validationError.${name}`,
              value,
            ),
          ),
      );

    return isValid && fraDateTimeTilDateTimeValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsTouched(true);
    if (isValid()) {
      setShowSokSpinner(true);
      dispatch(
        getElsparksykkelGebyr(
          elsparksykkelGebyrFilterForm,
          1,
          elsparksykkelGebyr.count,
        ),
      )
        .then(() => {
          setIsTouched(false);
          setShowSokSpinner(false);
        })
        .catch(() => {
          setIsTouched(false);
          setShowSokSpinner(false);
        });
    }
  };

  const handleChange = (e) => {
    if (touched) {
      isValid(e.target.name, e.target.value);
    }

    dispatch(
      handleChangeAction(
        "ELSPARKSYKKEL_GEBYR_FILTER_FORM",
        e.target.name,
        e.target.value,
      ),
    );
  };

  const handleChangeToInitState = () => {
    dispatch(handleChangeToInitStateAction("ELSPARKSYKKEL_GEBYR_FILTER_FORM"));
  };

  return (
    <div className="ettersendelse-filter-container">
      <h1>Søk etter elsparkesykler</h1>
      <form id="ettersendelse-filter" onSubmit={handleSubmit}>
        <div className="filter-flexbox-container ettersendelse-filter-flexbox-item">
          <TextInput
            label="Ileggelsesnummer"
            name="ileggelsesnummer"
            onChange={handleChange}
            value={elsparksykkelGebyrFilterForm.ileggelsesnummer}
            validationError={
              elsparksykkelGebyrFilterForm.validationError.ileggelsesnummer
            }
          />
          <FromToDateTimePickerNative
            from={{
              date: {
                id: "fraDato",
                name: "fraDato",
                label: "Dato fra",
                placeholder: "Velg",
                value: elsparksykkelGebyrFilterForm.fraDato,
                validationError:
                  elsparksykkelGebyrFilterForm.validationError
                    .fraDatoValidationErrorText,
              },
              time: {
                id: "fraTid",
                name: "fraTid",
                label: "Tid fra",
                placeholder: "Velg",
                value: elsparksykkelGebyrFilterForm.fraTid,
                validationError:
                  elsparksykkelGebyrFilterForm.validationError
                    .fraTidValidationErrorText,
              },
            }}
            to={{
              date: {
                id: "tilDato",
                name: "tilDato",
                label: "Dato til",
                placeholder: "Velg",
                value: elsparksykkelGebyrFilterForm.tilDato,
                validationError:
                  elsparksykkelGebyrFilterForm.validationError
                    .tilDatoValidationErrorText,
              },
              time: {
                id: "tilTid",
                name: "tilTid",
                label: "Tid til",
                placeholder: "Velg",
                value: elsparksykkelGebyrFilterForm.tilTid,
                validationError:
                  elsparksykkelGebyrFilterForm.validationError
                    .tilTidValidationErrorText,
              },
            }}
            onChange={handleChange}
          />
          <TextInput
            label="Tjenestenummer"
            name="tjenestenummer"
            onChange={handleChange}
            value={elsparksykkelGebyrFilterForm.tjenestenummer}
            validationError={
              elsparksykkelGebyrFilterForm.validationError.tjenestenummer
            }
          />
          <DropDown
            label="Aktør"
            name="aktorId"
            items={aktorer}
            selected={elsparksykkelGebyrFilterForm.aktorId}
            title="Velg"
            onChange={handleChange}
          />
          <DropDown
            label="Makulert"
            name="isMakulert"
            items={visAlleJaNei}
            selected={elsparksykkelGebyrFilterForm.isMakulert}
            title="Velg"
            onChange={handleChange}
          />
        </div>
        <div style={{ height: 20 }} />
        <div>
          <LoadButton
            buttonProps={{
              onClick: handleChangeToInitState,
              className: "btn-link",
              style: { height: 40, paddingRight: 17, paddingLeft: 0 },
            }}
            spinnerProps={{ pColor: "#ffffff", sColor: "#4d4d4d" }}
          >
            Tilbakestill
          </LoadButton>
          <LoadButton
            isLoading={showSokSpinner}
            buttonProps={{
              type: "submit",
              className: "btn-bym-action btn-bym-large",
              disabled: showSokSpinner,
            }}
            spinnerProps={{ pColor: "#ffffff", sColor: "#4d4d4d" }}
          >
            Søk
          </LoadButton>
        </div>
      </form>
    </div>
  );
};

export default FilterForm;
